//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name:'NewOrleans',
  data() {
    return {
      form:{
        gcs:'0',
        ageOver60:'0',
        headache:'0',
        vomiting:'0',

        drug:'0',

        amnesia:'0',
        trauma:'0',
        seizure:'0',

      },
      hasScore:false,
      disabled:false,
      defaultJson:{
        "Visible trauma above the clavicle": "锁骨以上的可见创伤",
        "Glasgow Coma Scale below 15": "Glasgow 昏迷评分低于 15 分",
        "Age > 60 years": "年龄 > 60 岁",
        "CT-Head indicated": "有头颅 CT 指征",
        "Decreased GCS": "GCS 下降",
        "Seizure": "抽搐",
        "Drug or alcohol intoxication": "药物或酒精中毒",
        "Vomiting": "呕吐",
        "Deficits in short-term memory": "短暂性记忆障碍",
        "Headache": "头痛",
        "CT-Head not required": "无需头颅 CT",
        "Persistent anterograde amnesia": "持续的顺行性遗忘"
      },
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算主要标准 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
            form[key]=0
          } else { 
            form[key] = Number(form[key])
          }
        }
      }

      // gcs + ageOver60 + headache + vomiting + drug + amnesia + trauma + seizure

      let result = form.gcs + form.ageOver60 + form.headache + form.vomiting + form.drug + form.amnesia + form.trauma + form.seizure
      self.hasScore = true
      return String(result)
    },
  },
  
  
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Trauma/NewOrleans.vue